export default __webpack_public_path__ + "static/m-and-s-6f35689d731b939e84a5cee4858e763f.png";